import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WarehouseStepper from './Stepper';
import styles from './styles.module.scss';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';

const WarehouseStepperInput = ({ item = {}, ...props }) => {
  const skladName = useSelector((store) => store.ui.skladName.short_name);
  const [data, setData] = useState({});

  useEffect(() => {
    setData(item);
  }, [item]);

  return (
    <>
      <Row>
        <Input
          value={data?.sklad_data?.[skladName]?.stock}
          fontSize="14px"
          textAlign="center"
          width={'35px'}
          readOnly
          styles={styles.bold_input}
          style={{ marginRight: '15px', fontWeight: 600 }}
        />
        <WarehouseStepper item={item} save={(v) => setData(v)} skladName={skladName} />
      </Row>
    </>
  );
};

export default WarehouseStepperInput;
